import cx from 'classnames'
import { CardElement } from '@stripe/react-stripe-js'
import {
  type StripeCardElement,
  type StripeCardElementOptions,
  type StripeElementChangeEvent,
} from '@stripe/stripe-js'
import { Help, FormGroup } from '@/components/Form'
import styles from './CardInput.module.css'

export interface CardInputProps {
  isDisabled: boolean
  error?: string
  onChange: (event: StripeElementChangeEvent) => void
  onReady: (element: StripeCardElement) => void
}

export function CardInput({
  isDisabled,
  error,
  onChange,
  onReady,
}: CardInputProps) {
  return (
    <FormGroup label="Credit or debit card" testId="add-card-form-card-input">
      <CardElement
        onChange={onChange}
        onReady={onReady}
        options={{
          ...CARD_ELEMENT_OPTIONS,
          disabled: isDisabled,
          classes: {
            ...CARD_ELEMENT_OPTIONS.classes,
            // Needed since we also populate errors ourselves.
            base: cx(
              CARD_ELEMENT_OPTIONS.classes?.base,
              error && styles.danger,
              isDisabled && styles.disabled,
            ),
          },
        }}
      />
      <Help error={error} />
    </FormGroup>
  )
}

const CARD_ELEMENT_OPTIONS: StripeCardElementOptions = {
  hidePostalCode: true,
  classes: {
    base: styles.control,
    invalid: styles.danger,
    focus: styles.focused,
  },
}
